import React from "react";
import ShowAllTransactions from "../../components/show_transactions/ShowAllTransactions";

function ShowAllIncome() {
  return <ShowAllTransactions type="income" headerTitle="Total income" />;
}

export default ShowAllIncome;
